import {   Box,
   Button,
   Table,
   TableBody,
   Checkbox,
   TextField,
   TableCell,
   TableContainer,
   TableHead,
   TableRow,
   Paper,
   Grid,
   IconButton, } from "@mui/material";
import { DataGrid,} from "@mui/x-data-grid";
import { useSelector } from "react-redux";
import "./Data.css";
import React, { useState, useEffect, useContext } from "react";
import { styled } from '@mui/system';

export default function AnalyzeTable() {
    const state = useSelector((store) => store.analyze);
   const { showChart, multiLineChartDataPrepared,tableData,selectedDataPoints,tableDataPrepared } = state;


    const { periods, seriesData } = multiLineChartDataPrepared;
   
   const { rows, columns } = tableDataPrepared;


   const [tableRows, setTableRows] = useState(tableData);
   const headers =
   tableData.length > 0
     ? Object.keys(tableData[0]).filter(
         (header) => header !== "dataSourceID" && header !== "localNo"
       )
     : [];

     useEffect(() => {
      setTableRows(tableData);
    }, [tableData]);

 const capitalizedHeaders = headers.map((item) => {
   console.log("Heardes",headers);
   return (item.charAt(0).toUpperCase() + item.slice(1)).replace(
     /([A-Z])/g,
     " $1"
   );
 });

 const PinnedHeaderCell = styled(TableCell)(({ theme }) => ({ 
   position: 'sticky', 
   left: 0, 
   top: 0, 
   backgroundColor: '#005587', 
   zIndex: 3, 
   minWidth: 200,
   color : 'white'
})); 

const PinnedTableCell = styled(TableCell)(({ theme }) => ({
   position: 'sticky',
   left: 0,
   backgroundColor: '#EEF2F4',
   zIndex: 1,
   minWidth: 200,
 }));

 const removeComma=(str)=> {
   let formattedString = "";
   for (let i = 0; i < str.length; i++) {
      if (str[i] !== ",") {
         formattedString += str[i];
      }
   }
   return formattedString;
}

   return (
      <Box sx={{ display: showChart ? "none" : "block" }}>
         {/* <DataGrid
            disableColumnMenu
            sx={{ maxHeight: "50vh", "& .MuiDataGrid-cell": { border: "1px solid #000" } }}
            rows={rows}
            columns={columns}
            disableSelectionOnClick
            slots={{
               SelectedRowCount:()=>null,
            }}
            getCellClassName={(params) => (params.field==='col1'?'frozen-cell':'')}
            getColumnHeaderClassName={(params) => params.field==='col1'?'frozen-header':''}
         ></DataGrid> */}

<TableContainer component={Paper}>
        <Table stickyHeader sx={{ minWidth: 650 }} aria-label="sticky table" >
          <TableHead>
            <TableRow>
              {capitalizedHeaders.map((header,index) => (
               index===0?(
                  <PinnedHeaderCell key={header}><b>{header}</b></PinnedHeaderCell>
               ):
                (<TableCell sx={{textAlign : "center"}}
                  key={header}
                  style={{ minWidth: header.minWidth, backgroundColor: '#EEF2F4', }}
                >
                  {header}
                </TableCell>)
              ))}
            </TableRow>
          </TableHead>
          <TableBody>
            {tableRows.map((row, index) => {
              const isDisabled = row.dataSourceID < 0;
              const isEditable = row.dataSourceID >= 1000;
              console.log("tableRows",tableRows);
              return (
                <>
                  <TableRow
                     key={row.dataSourceID}
                     hover
                  >

                    {/* <TableCell
                      style={{
                        backgroundColor: "white",
                      }}
                    >
                      {row.dataSourceName}
                    </TableCell> */}
                    {headers.map(
                      (header,index) =>
                      {
                        return index===0?(<PinnedTableCell key={`${index}-${header}`}><b>{row[header]}</b></PinnedTableCell>
                        ):(
                          <TableCell key={`${index}-${header}`} sx={{ textAlign : "center"}}>
                            {
                            (
                              row[header]
                            )
                            }
                          </TableCell>
                        )
                      }      
                    )}
                  </TableRow>
                </>
              );
            })}
          </TableBody>
        </Table>
      </TableContainer>

      </Box>
   
   );
}
